import React, { useState } from "react";
import { Input } from "@chakra-ui/react";

const TableInputTab = ({ item, setValuesInputs }) => {
    if (!item.input || item.input?.type === "checkbox") return null;

    const [value, setValue] = useState(item.input.value);
  
    return (
      <Input
        type={item.input.type}
        readOnly={item.input.readonly}
        width={item.input.size}
        isDisabled={item.input.disabled}
        value={value}
        className={item.input.class}
        onBlur={item.input.onBlur}
        onClick={(e) => e.stopPropagation()}
        onChange={(e) => {
          setValue(e.target.value);
          if (item.input.onChange) 
            item.input.onChange(e);

          if(setValuesInputs && typeof setValuesInputs == "function")
            setValuesInputs(e);
        }}
      />
    );
  };

  export default TableInputTab;